
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_fvjdu_1lqdy_99",
  "button": "awsui_button_fvjdu_1lqdy_142",
  "dots": "awsui_dots_fvjdu_1lqdy_143",
  "button-disabled": "awsui_button-disabled_fvjdu_1lqdy_171",
  "arrow": "awsui_arrow_fvjdu_1lqdy_176",
  "page-number": "awsui_page-number_fvjdu_1lqdy_186",
  "button-current": "awsui_button-current_fvjdu_1lqdy_192",
  "page-item": "awsui_page-item_fvjdu_1lqdy_209",
  "root-disabled": "awsui_root-disabled_fvjdu_1lqdy_227"
};
  